import React, {useRef, useState} from 'react';
import {useTranslation} from 'react-i18next';
import PropTypes from 'prop-types';
import {StyledAddPaymentModal} from './StyledAddPaymentModal';
import AddPaymentForm from '../AddPaymentForm';
import PaymentSuccessMessage from '../../../PaymentSuccessMessage';
import AnimatedSwitcher from '../../../../components/animations/AnimatedSwitcher';

const AddPaymentModal = ({
  initialFormData = {},
  open,
  onCancel,
  onSuccess,
  onValuesChange,
  vendorSelectorProps = {},
  ...rest
}) => {
  const [t] = useTranslation('main');
  const [loading, setLoading] = useState(false);
  const [isSuccessVisible, setIsSuccessVisible] = useState(false);

  const formRef = useRef(null);

  const afterOpenChange = (open) => {
    const form = formRef.current;
    if (form) {
      if (open) {
        form.setFieldsValue(initialFormData);
      } else {
        form.resetFields();
      }
    }
    if (!open && isSuccessVisible) setIsSuccessVisible(false);
  }

  const handleOnSuccess = (props) => {
    setLoading(false);
    setIsSuccessVisible(true);
    onSuccess && onSuccess(props);
  }

  const onError = () => setLoading(false);

  const handleOnOk = () => formRef.current && formRef.current.submit();

  const handleBeforeSubmit = () => setLoading(true);

  const modalOverrides = isSuccessVisible ? {title: null, footer: null} : {};

  const items = [
    {
      key: 'form',
      component: (
        <AddPaymentForm
          beforeSubmit={handleBeforeSubmit}
          initialFormData={initialFormData}
          onValuesChange={onValuesChange}
          onError={onError}
          onSuccess={handleOnSuccess}
          ref={formRef}
          vendorSelectorProps={vendorSelectorProps}
        />
      ),
    },
    {
      key: 'success',
      component: <PaymentSuccessMessage onClose={onCancel}/>,
    }
  ];

  const displayedKey = isSuccessVisible ? 'success' : 'form';

  return (
    <StyledAddPaymentModal
      afterOpenChange={afterOpenChange}
      open={open}
      cancelText={t('cancel')}
      okText={`${t('pay')} ${t('now')}`}
      cancelButtonProps={{size: 'large'}}
      okButtonProps={{loading, size: 'large', type: 'primary'}}
      onCancel={onCancel}
      onOk={handleOnOk}
      width={486}
      title={`${t('new')} ${t('payment')}`}
      {...modalOverrides}
      {...rest}
    >
      <AnimatedSwitcher items={items} displayedKey={displayedKey} />
    </StyledAddPaymentModal>
  );
}

AddPaymentModal.propTypes = {
  initialFormData: PropTypes.object,
  onCancel: PropTypes.func,
  onOk: PropTypes.func,
  onSuccess: PropTypes.func,
  onValuesChange: PropTypes.func,
  open: PropTypes.bool.isRequired,
  vendorSelectorProps: PropTypes.object,
}

export default AddPaymentModal;
